import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar-rapports',
  templateUrl: './navbar-rapports.component.html',
  styleUrls: ['./navbar-rapports.component.scss']
})
export class NavbarRapportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
